import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import styled from "styled-components";
import { createPortal } from "react-dom";
import { Select } from "../../form/select";
import { downloadJSON } from "../../../services/fileDownload";
import { webURL } from "../../../services/API";
import { PopupOverlay } from "../popupOverlay";

const types = [
   { id: 1, name: 'Select type', isActive: true, isHide: true },
   { id: 2, name: 'Chat Assistant', isActive: false },
   { id: 3, name: 'API Endpoint', isActive: false },
   { id: 4, name: 'Web Chat', isActive: false },
   { id: 5, name: 'Export as Template (JSON)', isActive: false }
];

export function ExportProject({ projectId, handleValuesFeatures }: { projectId?: string, handleValuesFeatures: (values: any) => void }) {
   const handleSelectLanguages = async (selectId: number) => {
      if (selectId === 2) handleValuesFeatures({ isChat: true, isExport: false });
      else if (selectId === 3) handleValuesFeatures({ isAPI: true, isExport: false });
      else if (selectId === 4) handleValuesFeatures({ isWebChat: true, isExport: false });
      else if (selectId === 5) {
         if (!projectId) return;
         try {
            const { data } = await axios.get(`${webURL}/projects/export-template?id=${projectId}`);
            downloadJSON(data, `${data?.metadata?.templateId || 'workflow'}.json`);
         } catch (err) {
            console.log(err);
            alert('Export failed — check the console for details.');
         }
         handleValuesFeatures({ isExport: false });
      }
   }

   const portalTarget = typeof document !== "undefined" ? document.body : null;
   if (!portalTarget) return null;

   return createPortal(
      <PopupOverlay onClick={ _=> handleValuesFeatures({ isExport: false }) }>
         <Main onClick={ e => e.stopPropagation() }>
            <div className="close" onClick={ _=> handleValuesFeatures({ isExport: false }) }>
               <FontAwesomeIcon icon={ faTimes } />
            </div>
            <h4>Workflow export type:</h4>
            <Select data={ types } handleSelectItem={ handleSelectLanguages } />
         </Main>
      </PopupOverlay>,
      portalTarget
   );
}

// ---
const Main = styled.div`
   width: 400px;

   .close {
      top: 10px;
      right: 10px !important;
   }
   h4 {
      font-weight: 400;
      margin-bottom: 15px;
   }
`;